/* Import Leverege Modules */
import Unit from '@leverege/unit';
import { Plugins } from '@leverege/plugin';
import Util from './Util.js';
import UnitTypes from './UnitTypes.js';
import TimestampFormatter from './TimestampFormatter.js';
import TimestampFormatterModel from './TimestampFormatterModel.js';
import TimestampFormatterEditor from "./TimestampFormatterEditor.js";
import GeoPointFormatter from './GeoPointFormatter.js';
import GeoPointFormatterModel from './GeoPointFormatterModel.js';
import GeoPointFormatterEditor from "./GeoPointFormatterEditor.js";
import BooleanFormatter from './BooleanFormatter.js';
import BooleanFormatterModel from './BooleanFormatterModel.js';
import BooleanFormatterEditor from "./BooleanFormatterEditor.js";
import NumberFormatter from './NumberFormatter.js';
import NumberFormatterModel from './NumberFormatterModel.js';
import NumberFormatterEditor from "./NumberFormatterEditor.js";
import IntFormatter from './IntFormatter.js';
import IntFormatterModel from './IntFormatterModel.js';
import IntFormatterEditor from "./IntFormatterEditor.js";
import PercentFormatter from './PercentFormatter.js';
import PercentFormatterModel from './PercentFormatterModel.js';
import PercentFormatterEditor from "./PercentFormatterEditor.js";
/**
 * Sets up unit specific format models and editors.
 */
function createUnitSpecificObjects() {
  const types = Unit.getUnitTypes();
  const formatters = UnitTypes.createUnitFormatters();
  types.forEach(type => {
    // Get parameters
    const key = `${type[0].toUpperCase()}${type.substring(1)}`;
    const formatterType = Util.getFormatterTypeForType(type);

    // Add plugins
    Plugins.add('AttributeFormatter', {
      type: formatterType,
      formatter: formatters[`${key}Formatter`]
    });
    Plugins.add('Model', {
      type: formatterType,
      model: formatters[`${key}FormatterModel`]
    });
    Plugins.add('ModelEditor', {
      type: formatterType,
      editor: formatters[`${key}FormatterEditor`]
    });
  });
}

/**
 * Installs formatter plugins.
 * @param {Object} options - Options object.
 */
export default {
  install: options => {
    // Add unit plugins
    createUnitSpecificObjects();

    // Add timestamp plugins
    Plugins.add('AttributeFormatter', {
      type: TimestampFormatterModel.TYPE,
      formatter: TimestampFormatter
    });
    Plugins.add('Model', {
      type: TimestampFormatterModel.TYPE,
      model: TimestampFormatterModel
    });
    Plugins.add('ModelEditor', {
      type: TimestampFormatterModel.TYPE,
      editor: TimestampFormatterEditor
    });

    // Add geopoint plugins
    Plugins.add('AttributeFormatter', {
      type: GeoPointFormatterModel.TYPE,
      formatter: GeoPointFormatter
    });
    Plugins.add('Model', {
      type: GeoPointFormatterModel.TYPE,
      model: GeoPointFormatterModel
    });
    Plugins.add('ModelEditor', {
      type: GeoPointFormatterModel.TYPE,
      editor: GeoPointFormatterEditor
    });

    // Add boolean plugins
    Plugins.add('AttributeFormatter', {
      type: BooleanFormatterModel.TYPE,
      formatter: BooleanFormatter
    });
    Plugins.add('Model', {
      type: BooleanFormatterModel.TYPE,
      model: BooleanFormatterModel
    });
    Plugins.add('ModelEditor', {
      type: BooleanFormatterModel.TYPE,
      editor: BooleanFormatterEditor
    });

    // Add number plugins
    Plugins.add('AttributeFormatter', {
      type: IntFormatterModel.TYPE,
      formatter: IntFormatter
    });
    Plugins.add('Model', {
      type: IntFormatterModel.TYPE,
      model: IntFormatterModel
    });
    Plugins.add('ModelEditor', {
      type: IntFormatterModel.TYPE,
      editor: IntFormatterEditor
    });

    // Add number plugins
    Plugins.add('AttributeFormatter', {
      type: NumberFormatterModel.TYPE,
      formatter: NumberFormatter
    });
    Plugins.add('Model', {
      type: NumberFormatterModel.TYPE,
      model: NumberFormatterModel
    });
    Plugins.add('ModelEditor', {
      type: NumberFormatterModel.TYPE,
      editor: NumberFormatterEditor
    });

    // Add percent plugins
    Plugins.add('AttributeFormatter', {
      type: PercentFormatterModel.TYPE,
      formatter: PercentFormatter
    });
    Plugins.add('Model', {
      type: PercentFormatterModel.TYPE,
      model: PercentFormatterModel
    });
    Plugins.add('ModelEditor', {
      type: PercentFormatterModel.TYPE,
      editor: PercentFormatterEditor
    });
  }
};